import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource';
import { updateSpendControllerBaseline } from 'utils/apiRequests';
import { isEqual, isUndefined } from 'lodash';
import { colIdsToSum } from 'SpendController/utils';
import { spendFormatter } from 'utils/filterNames';
import { SumContainer } from './TableView.style';

import { ModuleRegistry } from '@ag-grid-community/core';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';

ModuleRegistry.registerModules([ClientSideRowModelModule, RichSelectModule]);

class TableView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sum: null,
		};
		this.gridRef = React.createRef();
		this.colIdToDisplayString = {
			spend: 'Spend',
			final_Savings: 'Final Savings',
			remaining_Spend_Pre: 'Remaining Budget',
			remaining_Spend_Wor: 'Remaining Budget',
			total_Savings: 'Total Savings',
		};
	}

	gridOptions = () => {
		const { data } = this.props;

		return {
			modules: AllModules,
			columnDefs: data.columnDefs,
			cacheBlockSize: 200,
			maxBlocksInCache: 6,
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowHeight: 35,
			rowModelType: 'serverSide',
			maxConcurrentDatasourceRequests: 1,
			multiSortKey: 'ctrl',
			enableRangeSelection: true,
			// suppressCutToClipboard: true,
			// singleClickEdit: true,
			// suppressClipboardPaste: true,
		};
	};

	defaultColDefs = {
		flex: 1,
		minWidth: 120,
		resizable: true,
		editable: false,
		menuTabs: ['columnsMenuTab'],
		// suppressMenu: true,
	};

	componentDidMount() {
		const { data, filters, selectedSpendType } = this.props;
		const tempDataModel = {
			tail_Spend_Type: {
				values: selectedSpendType,
				filterType: 'set',
				filter: 'agSetColumnFilter',
			},
		};
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
			filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
		};

		const datasource = ServerSideDataSource(
			gridOptionsnew,
			this.gridRef.current.columnApi,
			this.gridRef.current.api
		);
		this.gridRef.current.api.setServerSideDatasource(datasource);
	}

	componentDidUpdate(prevProps) {
		const {
			filters,
			uploadRefresh,
			selectedSpendType,
			workshopState,
			refresh,
		} = this.props;
		if (
			!isEqual(filters, prevProps.filters) ||
			!isEqual(uploadRefresh, prevProps.uploadRefresh) ||
			!isEqual(selectedSpendType, prevProps.selectedSpendType) ||
			!isEqual(workshopState, prevProps.workshopState) ||
			!isEqual(refresh, prevProps.refresh)
		) {
			const { data, selectedSpendType } = this.props;
			const tempDataModel = {
				tail_Spend_Type: {
					values: selectedSpendType,
					filterType: 'set',
					filter: 'agSetColumnFilter',
				},
			};
			const gridOptionsnew = {
				data,
				suppressRowClickSelection: true,
				...this.gridOptions(),
				filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				this.gridRef.current.columnApi,
				this.gridRef.current.api
			);
			this.gridRef.current.api.setServerSideDatasource(datasource);
		}
	}

	onGridReady = params => {
		// this.setState({ gridApi: params.api });
		this.props.setGridApi(params.api);
		const { data, filters, selectedSpendType } = this.props;
		const tempDataModel = {
			tail_Spend_Type: {
				values: selectedSpendType,
				filterType: 'set',
				filter: 'agSetColumnFilter',
			},
		};
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
			filters: Object.assign({}, filters, ...data.filterModel, tempDataModel),
		};
		const datasource = ServerSideDataSource(
			gridOptionsnew,
			params.columnApi,
			params.api
		);
		params.api.setServerSideDatasource(datasource);
	};

	handleCellValueChange = async event => {
		const { gridApi } = this.props;
		const selectedRowNodes = gridApi.getSelectedNodes();
		if (this.props.micro) {
			if (event.colDef.colId === 'is_this_vendor_business_critical') {
				if (event.newValue === 'YES') {
					event.data.recommended_Action = 'Continue to use';
				} else if (event.newValue === 'NO') {
					event.data.recommended_Action = 'Eliminate';
				}
			}
		}
		if (event.colDef.colId === 'recommended_Action') {
			const tempValue =
				event.data.recommended_Action === 'Eliminate'
					? 100
					: event.data.recommended_Action === 'Continue to use' ||
					  event.data.recommended_Action === 'N/A'
						? 0
						: event.data.savings_opportunity;
			event.data.savings_opportunity = tempValue;
		}
		if (
			event.oldValue &&
			event.newValue &&
			event.oldValue.toString() === event.newValue.toString() &&
			selectedRowNodes.length === 1
		) {
			return;
		}

		const modifiedRows = [];
		modifiedRows.push(event.data);

		if (isUndefined(event.data.concatenatedIds)) {
			delete event.data.total_Savings;
			await updateSpendControllerBaseline([
				{ ...event.data, spend: null, total_Savings: null },
			]);
		} else {
			delete event.data.iD;
			const resultArray = event.data.concatenatedIds
				.split(',')
				.map(item => ({ id: Number(item.trim()) }));
			const tempArray = resultArray.map(data => ({
				id: data.id,
				...event.data,
				spend: null,
				total_Savings: null,
			}));
			await updateSpendControllerBaseline(tempArray);
		}
		this.gridRef.current.api.refreshView();
	};
	onSelectionHandler = () => {
		const { gridApi } = this.props;
		const cellRange = gridApi.getCellRanges();

		const sumMap = new Map();
		cellRange.forEach(range => {
			const { startRow, endRow, columns } = range;
			const startIndex = Math.min(startRow.rowIndex, endRow.rowIndex);
			const endIndex = Math.max(startRow.rowIndex, endRow.rowIndex);
			columns.forEach(col => {
				const colId = col.getColId();

				if (colIdsToSum.includes(colId)) {
					let colSum = sumMap.get(this.colIdToDisplayString[colId]) || 0;

					for (let rowIndex = startIndex; rowIndex <= endIndex; rowIndex++) {
						const rowNode = gridApi.getDisplayedRowAtIndex(rowIndex);
						const value = rowNode.data[colId];
						if (typeof value === 'number') {
							colSum += value;
						}
					}

					sumMap.set(
						this.colIdToDisplayString[colId],
						spendFormatter(colSum, true)
					);
				}
			});
		});

		this.setState({ sum: sumMap });
		// setSelectedSum(sum);
	};

	render() {
		const { data } = this.props;

		return (
			<>
				<div style={{ height: '320px' }} className="ag-theme-balham">
					<AgGridReact
						{...this.gridOptions()}
						ref={this.gridRef}
						modules={AllModules}
						columnDefs={data.columnDefs}
						cacheBlockSize={200}
						defaultColDef={this.defaultColDefs}
						floatingFilter={true}
						maxBlocksInCache={6}
						onCellValueChanged={this.handleCellValueChange}
						enableGroupEdit={true}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={this.onGridReady}
						enableRangeSelection={true}
						// suppressCutToClipboard={true}
						suppressCellFocus={true}
						suppressClipboardPaste={true}
						onSelectionChanged={this.onSelectionHandler}
						// rowSelection={'multiple'}
					/>
				</div>

				<SumContainer>
					{this.state.sum !== null &&
						Array.from(this.state.sum).length > 0 &&
						Array.from(this.state.sum).map(([colId, sum]) => (
							<div key={colId}>
								Sum of {colId}: {sum}{' '}
							</div>
						))}
				</SumContainer>
			</>
		);
	}
}

export default TableView;
